import { render, staticRenderFns } from "./CrosswordOld.vue?vue&type=template&id=3dc98195&"
import script from "./CrosswordOld.vue?vue&type=script&lang=js&"
export * from "./CrosswordOld.vue?vue&type=script&lang=js&"
import style0 from "./CrosswordOld.vue?vue&type=style&index=0&id=3dc98195&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports